import React from 'react'
import PropTypes from 'prop-types'
import formatMessage from 'format-message'

import ReaderNavigationAnalyticsItem from './new_ReaderNavigationAnalyticsItem'

const ReaderNavigationItemAnalyticsContainer = props => {
  return (
    <div>
      <ReaderNavigationAnalyticsItem
        numItems={props.toolbarRow.numParagraphs}
        numCompletedItems={props.toolbarRow.numCompletedParagraphs}
        title={formatMessage('Reading')}
        outerDivStyles={'mt-1'}
      />

      <ReaderNavigationAnalyticsItem
        numItems={props.toolbarRow.numVideos}
        numCompletedItems={props.toolbarRow.numCompletedVideos}
        title={formatMessage('Videos')}
      />

      <ReaderNavigationAnalyticsItem
        numItems={props.toolbarRow.numAssessments}
        numCompletedItems={props.toolbarRow.numCompletedAssessments}
        title={formatMessage('Assessments')}
      />
    </div>
  )
}

ReaderNavigationItemAnalyticsContainer.propTypes = {
  toolbarRow: PropTypes.object.isRequired,
}

export default ReaderNavigationItemAnalyticsContainer
